import styled from 'styled-components';
import { Button } from '@simplywallst/ui-core';

export const DropdownButton = styled(Button)`
  ${({ theme }) => theme.typography.xSmall};
  box-shadow: none;
  &:disabled,
  &:hover {
    box-shadow: none;
  }
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  padding-right: ${({ theme }) => theme.x2spacePx}px;
  padding-left: ${({ theme }) => theme.x2spacePx}px;
`;
